import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { RouteMap } from '@common/constants/RouteMap';
import { useWebBridgeContext } from '@libs/app-bridge';
import { ProtectedRoute } from '@common/components/ProtectRoute';
import { scoreQueries } from '@common/queries/score';
import { useQuery } from '@tanstack/react-query';
import { useUserContext } from '@common/contexts/UserContext';

const MyObjectives = lazy(() => import('../pages/MyObjectives'));
const ObjectiveDetail = lazy(() => import('../pages/MyObjectives/ObjectiveDetail'));
const Historic = lazy(() => import('../pages/Historic'));
const CpfReport = lazy(() => import('../pages/CpfReport'));

export function Router() {
  const { shouldShowAppExclusiveContent } = useWebBridgeContext();
  const { isAuthenticated } = useUserContext();

  const { data: positiveCustomer } = useQuery({
    ...scoreQueries.score(),
    select: (data) => data.positiveCustomer,
    enabled: isAuthenticated,
  });

  const negativeCustomer = positiveCustomer === false;

  return (
    <>
      <Route
        path={RouteMap.Objectives}
        element={
          <ProtectedRoute shouldRedirect={negativeCustomer} redirectTo={RouteMap.Dashboard}>
            <MyObjectives />
          </ProtectedRoute>
        }
      />
      <Route
        path={RouteMap.ObjectiveDetail}
        element={
          <ProtectedRoute shouldRedirect={negativeCustomer} redirectTo={RouteMap.Dashboard}>
            <ObjectiveDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path={RouteMap.ObjectivesHistoric}
        element={
          <ProtectedRoute shouldRedirect={negativeCustomer} redirectTo={RouteMap.Dashboard}>
            <Historic />
          </ProtectedRoute>
        }
      />

      <Route
        path={RouteMap.CpfReport}
        element={
          <ProtectedRoute shouldRedirect={shouldShowAppExclusiveContent} redirectTo={RouteMap.Dashboard}>
            <CpfReport />
          </ProtectedRoute>
        }
      />
    </>
  );
}
